import { DAYS_PER_MONTH } from 'constants/payments';

import { CurrentProduct } from 'interfaces/Payments/payments';

export const isOneMonthProduct: ({ period, trial }: Partial<CurrentProduct>) => boolean = ({ period, trial }) =>
    period === trial && period === DAYS_PER_MONTH;

export const isPilatesBranch = (branchName: string | null): boolean =>
    branchName === 'pilates' || branchName === 'wallpilates';
